module.exports = __webpack_public_path__ + "img/d4df25b.png";